import React, { useState } from "react";
import icon from '../assets/images/icona.png';
import {Col,Row,Container, Label} from "reactstrap";
import Form from "../components/Form";
import Section from "./Section";
import ServicesCardMain from "../components/ServicesCardMain";
import Preloader from "../components/Preloader";
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';

const Noleggio = () =>{
    const powerOptions = [
        "10 KVA - 8 KW",
        "20 KVA - 16 KW",
        "30 KVA - 24 KW",
        "40 KVA - 32 KW",
        "60 KVA - 48 KW",
        "80 KVA - 64 KW",
        "100 KVA - 80 KW",
        "130 KVA - 100 KW",
        "150 KVA - 120 KW",
        "200 KVA - 160 KW",
        "300 KVA - 240 KW",
        "350 KVA - 280 KW",
        "400 KVA - 320 KW",
        "450 KVA - 360 KW",
        "500 KVA - 400 KW",
        "640 KVA - 512 KW",
        "720 KVA - 576 KW",
        "900 KVA - 720 KW",
        "1000 KVA - 800 KW",
        "1500 KVA - 1200 KW",
        "2000 KVA - 1600 KW"
    ]
    const daysOptions = [
        1,3,7,15,30,60,90,120,150,180
    ]
    const serviceOptions = [
        'Accensione solo in caso di emergenza (Max 1 ora)','Servizio orario lavorativo(Max 8 ore)','Servizio Continuativo 24 ore su 24'
    ]
    const provinciaOptions = [
        'Agrigento',
        'Alessandria',
        'Ancona',
        'Aosta',
        "L'Aquila",
        'Arezzo',
        'Ascoli-Piceno',
        'Asti',
        'Avellino',
        'Bari',
        'Barletta-Andria-Trani',
        'Belluno',
        'Benevento',
        'Bergamo',
        'Biella',
        'Bologna',
        'Bolzano',
        'Brescia',
        'Brindisi',
        'Cagliari',
        'Caltanissetta',
        'Campobasso',
        'Carbonia Iglesias',
        'Caserta',
        'Catania',
        'Catanzaro',
        'Chieti',
        'Como',
        'Cosenza',
        'Cremona',
        'Crotone',
        'Cuneo',
        'Enna',
        'Fermo',
        'Ferrara',
        'Firenze',
        'Foggia',
        'Forli-Cesena',
        'Frosinone',
        'Genova',
        'Gorizia',
        'Grosseto',
        'Imperia',
        'Isernia',
        'La-Spezia',
        'Latina',
        'Lecce',
        'Lecco',
        'Livorno',
        'Lodi',
        'Lucca',
        'Macerata',
        'Mantova',
        'Massa-Carrara',
        'Matera',
        'Medio Campidano',
        'Messina',
        'Milano',
        'Modena',
        'Monza-Brianza',
        'Napoli',
        'Novara',
        'Nuoro',
        'Ogliastra',
        'Olbia Tempio',
        'Oristano',
        'Padova',
        'Palermo',
        'Parma',
        'Pavia',
        'Perugia',
        'Pesaro-Urbino',
        'Pescara',
        'Piacenza',
        'Pisa',
        'Pistoia',
        'Pordenone',
        'Potenza',
        'Prato',
        'Ragusa',
        'Ravenna',
        'Reggio-Calabria',
        'Reggio-Emilia',
        'Rieti',
        'Rimini',
        'Roma',
        'Rovigo',
        'Salerno',
        'Sassari',
        'Savona',
        'Siena',
        'Siracusa',
        'Sondrio',
        'Taranto',
        'Teramo',
        'Terni',
        'Torino',
        'Trapani',
        'Trento',
        'Treviso',
        'Trieste',
        'Udine',
        'Varese',
        'Venezia',
        'Verbania',
        'Vercelli',
        'Verona',
        'Vibo-Valentia',
        'Vicenza',
        'Viterbo'
    ];
    
    const formLayout = {
        name:'noleggio',title:"RICHIEDI SUBITO IL TUO PREVENTIVO E NOLEGGIA UN GRUPPO ELETTROGENO",layout:[
            {fieldName:'potenza_gruppo',fieldDimensions:12,fieldLabel:'Potenza Gruppo Elettrogeno(KVA/KW)',fieldValidation:{required:true},fieldType:'select',options:powerOptions},
            {fieldName:'data_inizio_noleggio',fieldDimensions:12,fieldLabel:'Data Inizio Noleggio',fieldValidation:{required:true},fieldType:'date',options:[]},
            {fieldName:'provincia_destinazione',fieldDimensions:12,fieldLabel:'Provincia di destinazione',fieldValidation:{required:true},fieldType:'select',options:provinciaOptions},
            {fieldName:'periodo_minimo_noleggio',fieldDimensions:12,fieldLabel:'Periodo Minimo Noleggio (Giorni)',fieldValidation:{required:true},fieldType:'radio',options:daysOptions},
            {fieldName:'servizio',fieldDimensions:12,fieldLabel:'Servizio',fieldValidation:{required:true},fieldType:'radio',options:serviceOptions},
            {fieldName:'rumorosita',fieldDimensions:12,fieldLabel:'Rumorosità',fieldValidation:{required:true},fieldType:'radio',options:['Utilizzo in zona residenziale','Utilizzo in zona industriale']},
            {fieldName:'rifornimento',fieldDimensions:12,fieldLabel:'Rifornimento Carburante',fieldValidation:{required:true},fieldType:'radio',options:['Gasolio Escluso il gruppo elettrogeno viene consegnato e ritirato con lo stesso livello di carburante','Gasolio Incluso Servizio nolo a caldo: carburante, manutenzione ordinaria e straordinaria comprese']},
            {fieldName:'noleggio_cavi',fieldDimensions:12,fieldLabel:'Noleggio Cavi di Collegamento',fieldValidation:{required:true},fieldType:'radio',options:['Cavi Esclusi I cavi vengono forniti dal cliente, il collegamento dei cavi sul gruppo elettrogeno é incluso','Cavi Inclusi Kit Cavi(3F+N+T) da 25 mt di adeguato dimensionamento per la potenza richiesta. Specificare nelle Note eventuali esigenze specifiche.']},
            {fieldName:'note',fieldDimensions:12,fieldLabel:'Note Utilizzo e Installazione',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'azienda',fieldDimensions:12,fieldLabel:'Ragione sociale',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'piva_cf',fieldDimensions:6,fieldLabel:'Partita IVA / Codice Fiscale',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'indirizzo',fieldDimensions:6,fieldLabel:'Indirizzo Sede Legale',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'comune',fieldDimensions:6,fieldLabel:'Comune Sede Legale',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'provincia',fieldDimensions:6,fieldLabel:'Provincia Sede Legale',fieldValidation:{required:true},fieldType:'select',options:provinciaOptions},
            {fieldName:'telefono',fieldLabel:'Telefono',fieldDimensions:6,fieldValidation:{},fieldType:'number'},
            {fieldName:'email',fieldLabel:'Email',fieldDimensions:6,fieldValidation:{},fieldType:'email'},
        ]
    }    
    return ( <React.Fragment>
        <Preloader />
        <Navbar />     
        <Section leftSide="Noleggio" />
        <ServicesCardMain imgsrc={icon} title="Noleggio" caption="Tenergia s.r.l. offre la possibilità di noleggiare i suoi Gruppi elettrogeni e Torri faro con forme di locazione vantaggiose e personalizzate a breve e a lungo termine. La vasta scelta tra i nostri prodotti, rende questo tipo di soluzione adatta a diversi tipi di esigenze come lavorazioni edili, aziende agricole, impianti fotovoltaici, condomini, ristoranti, attività commerciali di ogni genere, feste private, eventi sportivi o emergenze di ogni tipo come blackout o allagamenti." />
          <Form name={formLayout.name} title={formLayout.title} layout={formLayout.layout}></Form>
          <Footer />
          <FooterAlt />
          </React.Fragment>)
}

export default Noleggio;